import { all } from 'redux-saga/effects';

import groupSagas from './group';

export default function* rootSaga() {
  yield all([groupSagas()]);
}
